import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Img from "gatsby-image"
import tw, { css }  from "twin.macro"

import SlideSection from "../components/slideSection"
import NextPageButton from "../components/nextPageButton"
import { SlideProps } from "."

const LogoSlide: React.SFC<SlideProps> = ({ nextButtonClicked, isClient }) => {

  const data = useStaticQuery(query);

  const logoSources = [
    data.squareLogo.childImageSharp.fixed,
    {
      ...data.landscapeLogo.childImageSharp.fixed,
      media: `(min-width: 768px)`,
    },
  ]

  return (
    <SlideSection>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        {isClient && <h1 css={[css`
          margin-top: -16rem;
          @media (min-width: 768px) {
            margin-top: -22rem;
          }
          `]}
        ><Img css={[
          tw`content-center`]} fixed={logoSources} /></h1>}
        <div css={[tw`absolute bottom-0 mb-16`]}>
          <NextPageButton onClick={nextButtonClicked} label="Go" />
        </div>
      </div>
    </SlideSection>
  )
}

export const query = graphql`
  query {
    squareLogo: file(relativePath: { eq: "LogoSquare.png" }) {
      childImageSharp {
        fixed(width: 201, height: 192) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
    landscapeLogo: file(relativePath: { eq: "LogoLandscape.png" }) {
      childImageSharp {
        fixed(width: 735, height: 100) {
          ...GatsbyImageSharpFixed_noBase64
        }
      }
    }
  }
`

export default LogoSlide
